export default "__VITE_ASSET__3202faca__"